import React from 'react'
import Sidebar from './Sidebar'

const Navbar = () => {
  return (
     <nav className='sticky-top bg-white'>
        <div className='flex justify-between items-center h-[60px] shadow-md px-2'>
        <img src='/assets/logo.png' alt='logo' className='w-[70px] h-[60px]'/>
         <div className='flex items-center'>
             <img 
                     src='/assets/avatar.jpg' 
                     alt='avatar.jpg' 
                     className='  md:h-[35px] md:w-[35px] rounded-full'
              />
              <button className='text-[16px] mr-3 hidden sm:inline-block'>
                   &nbsp; Site Admin <span className='bi bi-chevron-down'></span>
              </button>
              {/*display sidebar for mobile devices */}
              <button 
                   className='sm:hidden ml-8 bi bi-justify text-gray-800 text-4xl'
                   data-bs-toggle='offcanvas'
                   data-bs-target='#sidebar' 
                   aria-controls='sidebar'
               >               
               </button>                      
                  <div>     
                     <div className='offcanvas mobile-sidebar' 
                          tabIndex='-1' id='sidebar'                            
                       >
                        <div className='mobile-sidebar-header'>
                           <button className='mobile-sidebar-close-btn' data-bs-dismiss='offcanvas'></button>
                        </div>
                        <div className='offcanvas-body flex-grow p-0 overflow-y-auto'>
                           <Sidebar />
                       </div>
                  </div>
               </div>                 
          </div>
       </div>
     </nav>
  )
}

export default Navbar
